let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8hXQt")).then(() => parcelRequire('7Y0pd'));